import { Roles } from './roles';

export function getPrimaryRole(roles: string[]): string {
  const rolePriority = [
    Roles.seniorManager,
    Roles.manager,
    Roles.seniorOperator,
    Roles.operator,
    Roles.observer,
  ];

  return rolePriority.find((role) => roles.includes(role)) ?? Roles.anonymous;
}
